import React from 'react'
import PropTypes from 'prop-types'
import { Alert, Box, CircularProgress } from '@mui/material'
import { t } from 'i18next'

const T = 'YAPPY_PAYMENT_T'

function YappyButtonSection({
  buttonKey,
  transactionId,
  buttonVisible,
  isPhoneValid,
  yappyButtonRef,
  yappyScriptLoaded,
  yappyScriptError,
  yappyOnline,
}) {
  return (
    <Box
      className="yappy-btn-wrapper"
      style={buttonVisible ? undefined : { visibility: 'hidden' }}>
      {yappyScriptError ? (
        <Alert severity="error" sx={{ fontSize: '1.3rem' }}>
          {t(`${T}.SCRIPT_ERROR`)}
        </Alert>
      ) : (
        <>
          {yappyScriptLoaded && (
            <div
              style={
                isPhoneValid
                  ? undefined
                  : { pointerEvents: 'none', opacity: 0.5 }
              }>
              <btn-yappy
                key={`${transactionId}-${buttonKey}`}
                ref={yappyButtonRef}
                theme="darkBlue"
                style={{ display: yappyOnline === true ? undefined : 'none' }}
              />
            </div>
          )}
          {(!yappyScriptLoaded || yappyOnline === null) && (
            <Box
              sx={{
                width: 210,
                height: 47,
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'flex-end',
                pr: '26px',
              }}>
              <CircularProgress size={28} />
            </Box>
          )}
          {yappyOnline === false && (
            <Alert severity="warning" sx={{ fontSize: '1.3rem' }}>
              {t(`${T}.YAPPY_OFFLINE`)}
            </Alert>
          )}
        </>
      )}
    </Box>
  )
}

YappyButtonSection.propTypes = {
  buttonKey: PropTypes.number.isRequired,
  transactionId: PropTypes.string,
  buttonVisible: PropTypes.bool.isRequired,
  isPhoneValid: PropTypes.bool.isRequired,
  yappyButtonRef: PropTypes.func.isRequired,
  yappyScriptLoaded: PropTypes.bool.isRequired,
  yappyScriptError: PropTypes.bool.isRequired,
  yappyOnline: PropTypes.bool,
}

export default YappyButtonSection
